import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const SEPTEMBER_2025_CAMPAIGN_END_DATE = d(2025, 10, 1, 0, 0);
